import { CssBaseline } from '@mui/material';
import { StyledEngineProvider, ThemeProvider, createTheme } from '@mui/material/styles';
import * as ReactDOM from 'react-dom/client';
import './index.css';
import './App.scss';
import App from './App';

const theme = createTheme({
  typography: {
    fontFamily: 'Rubik',
  },
  components: {
    MuiAutocomplete: {
      defaultProps: {
        noOptionsText: 'Não há opções',
        loadingText: 'Carregando...',
      },
    },
  },
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <StyledEngineProvider injectFirst>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <App />
    </ThemeProvider>
  </StyledEngineProvider>,
);
